import { render, staticRenderFns } from "./ProfilePhotoModal.vue?vue&type=template&id=2c6f141c&scoped=true&"
import script from "./ProfilePhotoModal.vue?vue&type=script&lang=js&"
export * from "./ProfilePhotoModal.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePhotoModal.vue?vue&type=style&index=0&id=2c6f141c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f141c",
  null
  
)

export default component.exports